export default __webpack_public_path__ + "static/media/agriculturaManu.f7049182.jpg";